(function () {
  'use strict';

  if (window.MyfeltProfessionalSections) {
    window.MyfeltProfessionalSections.init(document);
    return;
  }

  var roomControllers = new Map();
  var referenceControllers = new Map();
  var focusedStatuses = new WeakSet();
  var swiperWaitTimer = null;
  var swiperWaitAttempts = 0;
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function matchesIncludingRoot(root, selector) {
    var matches = [];

    if (!root) return matches;
    if (root.nodeType === 1 && root.matches(selector)) matches.push(root);
    if (root.querySelectorAll) {
      matches = matches.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }

    return matches;
  }

  function addListener(controller, target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    controller.listeners.push(function () {
      target.removeEventListener(eventName, handler, options);
    });
  }

  function initRoomSolutions(root) {
    matchesIncludingRoot(root, '[data-professional-room-solutions]').forEach(function (section) {
      if (roomControllers.has(section)) return;

      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-room-tab]'));
      var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-room-trigger]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-room-panel]'));
      var items = Array.prototype.slice.call(section.querySelectorAll('[data-room-item]'));

      if (!panels.length) return;

      var controller = {
        activeIndex: 0,
        listeners: [],
        activate: function (requestedIndex, shouldFocus) {
          var index = Number(requestedIndex);
          if (!Number.isInteger(index) || index < 0 || index >= panels.length) index = 0;
          controller.activeIndex = index;

          tabs.forEach(function (tab, tabIndex) {
            var isActive = tabIndex === index;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.setAttribute('tabindex', isActive ? '0' : '-1');
          });

          triggers.forEach(function (trigger, triggerIndex) {
            var isActive = triggerIndex === index;
            trigger.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel, panelIndex) {
            var isActive = panelIndex === index;
            panel.hidden = !isActive;
            panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });

          items.forEach(function (item, itemIndex) {
            item.classList.toggle('is-active', itemIndex === index);
          });

          if (shouldFocus && tabs[index]) tabs[index].focus();
        },
        destroy: function () {
          controller.listeners.forEach(function (removeListener) {
            removeListener();
          });
          controller.listeners = [];
        }
      };

      tabs.forEach(function (tab, index) {
        addListener(controller, tab, 'click', function () {
          controller.activate(index, false);
        });

        addListener(controller, tab, 'keydown', function (event) {
          var nextIndex = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          if (nextIndex !== null) {
            event.preventDefault();
            controller.activate(nextIndex, true);
          }
        });
      });

      triggers.forEach(function (trigger, index) {
        addListener(controller, trigger, 'click', function () {
          controller.activate(index, false);
        });
      });

      var initiallySelected = tabs.findIndex(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      });

      roomControllers.set(section, controller);
      controller.activate(initiallySelected >= 0 ? initiallySelected : 0, false);
    });
  }

  function updateReferenceProgress(section, swiper) {
    var count = Number(section.getAttribute('data-reference-count')) || 0;
    var progress = section.querySelector('[data-reference-progress]');
    var progressBar = section.querySelector('[data-reference-progress-bar]');
    if (!progress || !progressBar || count < 1) return;

    var activeSlide = swiper && swiper.slides ? swiper.slides[swiper.activeIndex] : null;
    var slideIndex = activeSlide ? Number(activeSlide.getAttribute('data-reference-index')) : NaN;
    var realIndex = Number.isFinite(slideIndex)
      ? slideIndex
      : swiper && Number.isFinite(Number(swiper.realIndex))
        ? Number(swiper.realIndex)
        : 0;
    var current = ((realIndex % count) + count) % count + 1;

    progress.setAttribute('aria-valuenow', String(current));
    progress.setAttribute('aria-valuetext', current + ' von ' + count);
    progressBar.style.width = (current / count) * 100 + '%';
  }

  function removeDuplicateSlidesFromAccessibility(section) {
    var focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';

    section.querySelectorAll('.swiper-slide-duplicate').forEach(function (slide) {
      slide.setAttribute('aria-hidden', 'true');
      slide.querySelectorAll(focusableSelector).forEach(function (element) {
        element.setAttribute('tabindex', '-1');
      });
    });
  }

  function createReferenceSlideSets(swiperElement) {
    var wrapper = swiperElement.querySelector('.swiper-wrapper');
    var originals = wrapper
      ? Array.prototype.filter.call(wrapper.children, function (child) {
          return (
            child.classList.contains('professional-references__slide') &&
            !child.classList.contains('swiper-slide-duplicate')
          );
        })
      : [];
    var clones = [];

    if (!wrapper || originals.length < 2) {
      return { count: originals.length, remove: function () {} };
    }

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();

    originals.forEach(function (slide) {
      var beforeClone = slide.cloneNode(true);
      var afterClone = slide.cloneNode(true);

      [beforeClone, afterClone].forEach(function (clone) {
        clone.classList.add('swiper-slide-duplicate');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clones.push(clone);
      });

      before.appendChild(beforeClone);
      after.appendChild(afterClone);
    });

    wrapper.insertBefore(before, originals[0]);
    wrapper.appendChild(after);

    return {
      count: originals.length,
      remove: function () {
        clones.forEach(function (clone) {
          if (clone.parentNode) clone.parentNode.removeChild(clone);
        });
      }
    };
  }

  function queueSwiperInitialization() {
    if (swiperWaitTimer || swiperWaitAttempts >= 100) return;

    swiperWaitTimer = window.setTimeout(function checkForSwiper() {
      swiperWaitTimer = null;
      swiperWaitAttempts += 1;

      if (typeof window.Swiper === 'function') {
        swiperWaitAttempts = 0;
        initReferenceCarousels(document);
        return;
      }

      queueSwiperInitialization();
    }, 50);
  }

  function initReferenceCarousels(root) {
    matchesIncludingRoot(root, '[data-professional-references]').forEach(function (section) {
      if (referenceControllers.has(section)) return;

      var count = Number(section.getAttribute('data-reference-count')) || 0;
      var swiperElement = section.querySelector('[data-reference-swiper]');
      if (!swiperElement || count < 1) return;

      if (count === 1) {
        updateReferenceProgress(section, null);
        referenceControllers.set(section, {
          instance: null,
          destroy: function () {}
        });
        return;
      }

      if (typeof window.Swiper !== 'function') {
        queueSwiperInitialization();
        return;
      }

      var previousButton = section.querySelector('[data-reference-prev]');
      var nextButton = section.querySelector('[data-reference-next]');
      var slideSets = createReferenceSlideSets(swiperElement);
      var normalizing = false;
      var navigationLocked = false;
      var navigationUnlockTimer = null;

      function alignReferenceStart(instance, targetIndex, duration) {
        var targetSlide = instance && instance.slides ? instance.slides[targetIndex] : null;
        var targetOffset = targetSlide ? Number(targetSlide.offsetLeft) : NaN;

        if (
          targetSlide &&
          Number.isFinite(targetOffset) &&
          typeof instance.setTransition === 'function' &&
          typeof instance.setTranslate === 'function'
        ) {
          instance.setTransition(duration);
          instance.setTranslate(instance.rtlTranslate ? targetOffset : -targetOffset);

          if (typeof instance.updateActiveIndex === 'function') instance.updateActiveIndex(targetIndex);
          if (typeof instance.updateSlidesClasses === 'function') instance.updateSlidesClasses();
          updateReferenceProgress(section, instance);
          return;
        }

        instance.slideTo(targetIndex, duration, true);
      }

      function normalizeReferencePosition(instance, preserveFreePosition) {
        if (!instance || normalizing || slideSets.count < 2) return;

        var activeIndex = Number(instance.activeIndex) || 0;
        var targetIndex = null;

        if (activeIndex < slideSets.count) {
          targetIndex = activeIndex + slideSets.count;
        } else if (activeIndex >= slideSets.count * 2) {
          targetIndex = activeIndex - slideSets.count;
        }

        if (targetIndex === null) return;
        normalizing = true;

        if (
          preserveFreePosition &&
          instance.slidesGrid &&
          typeof instance.setTranslate === 'function' &&
          typeof instance.updateActiveIndex === 'function'
        ) {
          var currentGrid = Number(instance.slidesGrid[activeIndex]);
          var targetGrid = Number(instance.slidesGrid[targetIndex]);

          if (Number.isFinite(currentGrid) && Number.isFinite(targetGrid)) {
            var gridDelta = targetGrid - currentGrid;
            var nextTranslate = instance.rtlTranslate
              ? Number(instance.translate) + gridDelta
              : Number(instance.translate) - gridDelta;

            instance.setTranslate(nextTranslate);
            instance.updateActiveIndex(targetIndex);
            if (typeof instance.updateSlidesClasses === 'function') instance.updateSlidesClasses();
          } else {
            alignReferenceStart(instance, targetIndex, 0);
          }
        } else {
          alignReferenceStart(instance, targetIndex, 0);
        }

        normalizing = false;
        updateReferenceProgress(section, instance);
      }

      var swiper = new window.Swiper(swiperElement, {
        loop: false,
        rewind: false,
        initialSlide: slideSets.count,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesOffsetBefore: 0,
        slideToClickedSlide: false,
        spaceBetween: 8,
        roundLengths: false,
        preventInteractionOnTransition: true,
        threshold: 4,
        freeMode: true,
        freeModeSticky: false,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.65,
        freeModeMomentumVelocityRatio: 0.7,
        freeModeMomentumBounce: false,
        breakpoints: {
          481: {
            spaceBetween: 12,
            freeMode: false
          },
          1200: {
            spaceBetween: 16,
            freeMode: false
          }
        },
        speed: reduceMotionQuery.matches ? 0 : 500,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Vorherige Referenz',
          nextSlideMessage: 'Nächste Referenz',
          firstSlideMessage: 'Erste Referenz',
          lastSlideMessage: 'Letzte Referenz'
        },
        on: {
          init: function (instance) {
            updateReferenceProgress(section, instance);
            removeDuplicateSlidesFromAccessibility(section);
            window.requestAnimationFrame(function () {
              if (typeof instance.update === 'function') instance.update();
              alignReferenceStart(instance, slideSets.count, 0);
              updateReferenceProgress(section, instance);
            });
          },
          slideChange: function (instance) {
            updateReferenceProgress(section, instance);
          },
          transitionEnd: function (instance) {
            normalizeReferencePosition(instance, window.matchMedia('(max-width: 480px)').matches);
          },
          touchEnd: function (instance) {
            window.requestAnimationFrame(function () {
              normalizeReferencePosition(instance, true);
            });
          },
          slidesUpdated: function () {
            removeDuplicateSlidesFromAccessibility(section);
          }
        }
      });

      function moveReference(direction) {
        if (!swiper || swiper.animating || normalizing || navigationLocked) return;

        var activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
        var currentReference = activeSlide ? Number(activeSlide.getAttribute('data-reference-index')) : 0;
        if (!Number.isFinite(currentReference)) currentReference = 0;

        var targetReference = (currentReference + direction + slideSets.count) % slideSets.count;
        var targetIndex = slideSets.count + targetReference;
        var duration = reduceMotionQuery.matches ? 0 : 500;

        navigationLocked = duration > 0;
        alignReferenceStart(swiper, targetIndex, duration);

        if (navigationLocked) {
          navigationUnlockTimer = window.setTimeout(function () {
            navigationLocked = false;
            navigationUnlockTimer = null;
          }, duration);
        }
      }

      function handlePreviousClick(event) {
        event.preventDefault();
        moveReference(-1);
      }

      function handleNextClick(event) {
        event.preventDefault();
        moveReference(1);
      }

      if (previousButton) previousButton.addEventListener('click', handlePreviousClick);
      if (nextButton) nextButton.addEventListener('click', handleNextClick);

      referenceControllers.set(section, {
        instance: swiper,
        destroy: function () {
          if (previousButton) previousButton.removeEventListener('click', handlePreviousClick);
          if (nextButton) nextButton.removeEventListener('click', handleNextClick);
          if (navigationUnlockTimer) window.clearTimeout(navigationUnlockTimer);
          if (swiper && typeof swiper.destroy === 'function') swiper.destroy(true, true);
          slideSets.remove();
        }
      });
    });
  }

  function initNativeReferenceCarousels(root) {
    matchesIncludingRoot(root, '[data-professional-references]').forEach(function (section) {
      if (referenceControllers.has(section)) return;

      var count = Number(section.getAttribute('data-reference-count')) || 0;
      var viewport = section.querySelector('[data-reference-swiper]');
      if (!viewport || count < 1) return;

      if (count === 1) {
        updateReferenceProgress(section, null);
        referenceControllers.set(section, { instance: null, destroy: function () {} });
        return;
      }

      var previousButton = section.querySelector('[data-reference-prev]');
      var nextButton = section.querySelector('[data-reference-next]');
      var slideSets = createReferenceSlideSets(viewport);
      var wrapper = viewport.querySelector('.swiper-wrapper');
      var slides = Array.prototype.slice.call(wrapper.children);
      var mobileQuery = window.matchMedia('(max-width: 767px)');
      var activeReferenceIndex = 0;
      var navigationLocked = false;
      var navigationUnlockTimer = null;
      var desktopTranslate = 0;
      var dragPointerId = null;
      var dragStartX = 0;
      var dragStartTranslate = 0;
      var dragStartIndex = 0;
      var dragMoved = false;
      var suppressClick = false;

      viewport.classList.add('professional-references__custom-slider');
      viewport.setAttribute('tabindex', '0');
      removeDuplicateSlidesFromAccessibility(section);

      function middleIndex(referenceIndex) {
        return slideSets.count + referenceIndex;
      }

      function updateProgress(referenceIndex) {
        updateReferenceProgress(section, {
          slides: slides,
          activeIndex: middleIndex(referenceIndex),
          realIndex: referenceIndex
        });
      }

      function alignDesktop(targetIndex, duration) {
        var targetSlide = slides[targetIndex];
        if (!targetSlide) return;

        desktopTranslate = -targetSlide.offsetLeft;
        wrapper.style.transitionDuration = duration + 'ms';
        wrapper.style.transform = 'translate3d(' + desktopTranslate + 'px, 0, 0)';

        var referenceIndex = Number(targetSlide.getAttribute('data-reference-index'));
        if (Number.isFinite(referenceIndex)) {
          activeReferenceIndex = referenceIndex;
          updateProgress(referenceIndex);
        }
      }

      function nearestSlideIndex(translate) {
        var targetOffset = -translate;
        var nearestIndex = 0;
        var nearestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - targetOffset);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      }

      function finishDesktopDrag(event) {
        if (dragPointerId === null || (event && event.pointerId !== dragPointerId)) return;

        var releasedPointerId = dragPointerId;
        var dragDistance = desktopTranslate - dragStartTranslate;
        var targetIndex = nearestSlideIndex(desktopTranslate);

        dragPointerId = null;
        viewport.classList.remove('is-dragging');

        if (viewport.hasPointerCapture && viewport.hasPointerCapture(releasedPointerId)) {
          viewport.releasePointerCapture(releasedPointerId);
        }

        if (dragMoved && targetIndex === dragStartIndex && Math.abs(dragDistance) >= 40) {
          targetIndex = Math.max(0, Math.min(slides.length - 1, dragStartIndex + (dragDistance < 0 ? 1 : -1)));
        }

        var targetSlide = slides[targetIndex];
        var referenceIndex = targetSlide ? Number(targetSlide.getAttribute('data-reference-index')) : NaN;
        if (!Number.isFinite(referenceIndex)) referenceIndex = activeReferenceIndex;

        activeReferenceIndex = referenceIndex;
        updateProgress(referenceIndex);

        var duration = dragMoved && !reduceMotionQuery.matches ? 350 : 0;
        navigationLocked = duration > 0;
        alignDesktop(targetIndex, duration);

        if (navigationUnlockTimer) window.clearTimeout(navigationUnlockTimer);
        navigationUnlockTimer = window.setTimeout(function () {
          alignDesktop(middleIndex(activeReferenceIndex), 0);
          navigationLocked = false;
          navigationUnlockTimer = null;
        }, duration);

        suppressClick = dragMoved;
        window.setTimeout(function () {
          suppressClick = false;
        }, 0);
      }

      function normalizeMobileScroll() {
        if (!mobileQuery.matches || slides.length < slideSets.count * 3) return;

        var middleStart = slides[slideSets.count].offsetLeft;
        var nextStart = slides[slideSets.count * 2].offsetLeft;
        var cycleWidth = nextStart - middleStart;
        if (cycleWidth <= 0) return;

        if (viewport.scrollLeft < middleStart) {
          viewport.scrollLeft += cycleWidth;
        } else if (viewport.scrollLeft >= nextStart) {
          viewport.scrollLeft -= cycleWidth;
        }

        var nearestIndex = slideSets.count;
        var nearestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        var referenceIndex = Number(slides[nearestIndex].getAttribute('data-reference-index'));
        if (Number.isFinite(referenceIndex)) {
          activeReferenceIndex = referenceIndex;
          updateProgress(referenceIndex);
        }
      }

      function applyResponsiveMode() {
        wrapper.style.transitionDuration = '0ms';

        if (mobileQuery.matches) {
          wrapper.style.transform = 'none';
          viewport.scrollLeft = slides[middleIndex(activeReferenceIndex)].offsetLeft;
          normalizeMobileScroll();
        } else {
          viewport.scrollLeft = 0;
          alignDesktop(middleIndex(activeReferenceIndex), 0);
        }
      }

      function moveReference(direction) {
        if (navigationLocked || mobileQuery.matches) return;

        var targetReference = (activeReferenceIndex + direction + slideSets.count) % slideSets.count;
        var targetIndex = middleIndex(targetReference);
        var duration = reduceMotionQuery.matches ? 0 : 500;

        if (direction > 0 && activeReferenceIndex === slideSets.count - 1) {
          targetIndex = slideSets.count * 2;
        } else if (direction < 0 && activeReferenceIndex === 0) {
          targetIndex = slideSets.count - 1;
        }

        navigationLocked = true;
        alignDesktop(targetIndex, duration);

        navigationUnlockTimer = window.setTimeout(function () {
          activeReferenceIndex = targetReference;
          alignDesktop(middleIndex(targetReference), 0);
          navigationLocked = false;
          navigationUnlockTimer = null;
        }, duration);
      }

      function handlePreviousClick(event) {
        event.preventDefault();
        moveReference(-1);
      }

      function handleNextClick(event) {
        event.preventDefault();
        moveReference(1);
      }

      function handleScroll() {
        window.requestAnimationFrame(normalizeMobileScroll);
      }

      function handlePointerDown(event) {
        if (mobileQuery.matches || navigationLocked || event.button !== 0 || event.isPrimary === false) return;

        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartTranslate = desktopTranslate;
        dragStartIndex = nearestSlideIndex(desktopTranslate);
        dragMoved = false;
        wrapper.style.transitionDuration = '0ms';
        viewport.classList.add('is-dragging');
      }

      function handlePointerMove(event) {
        if (event.pointerId !== dragPointerId || mobileQuery.matches) return;

        var dragDistance = event.clientX - dragStartX;
        if (!dragMoved && Math.abs(dragDistance) >= 4) {
          dragMoved = true;
          viewport.setPointerCapture(event.pointerId);
        }
        if (dragMoved) event.preventDefault();

        desktopTranslate = dragStartTranslate + dragDistance;
        wrapper.style.transform = 'translate3d(' + desktopTranslate + 'px, 0, 0)';
      }

      function handlePointerUp(event) {
        finishDesktopDrag(event);
      }

      function handleClick(event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }

      function handleDragStart(event) {
        event.preventDefault();
      }

      function handleKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveReference(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveReference(1);
        }
      }

      function handleMediaChange() {
        window.requestAnimationFrame(applyResponsiveMode);
      }

      if (previousButton) previousButton.addEventListener('click', handlePreviousClick);
      if (nextButton) nextButton.addEventListener('click', handleNextClick);
      viewport.addEventListener('scroll', handleScroll, { passive: true });
      viewport.addEventListener('keydown', handleKeydown);
      viewport.addEventListener('pointerdown', handlePointerDown);
      viewport.addEventListener('pointermove', handlePointerMove);
      viewport.addEventListener('pointerup', handlePointerUp);
      viewport.addEventListener('pointercancel', handlePointerUp);
      viewport.addEventListener('click', handleClick, true);
      viewport.addEventListener('dragstart', handleDragStart);
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', handleMediaChange);
      else mobileQuery.addListener(handleMediaChange);

      window.requestAnimationFrame(applyResponsiveMode);

      referenceControllers.set(section, {
        instance: null,
        goToReference: function (referenceIndex) {
          activeReferenceIndex = referenceIndex;
          if (mobileQuery.matches) {
            viewport.scrollLeft = slides[middleIndex(referenceIndex)].offsetLeft;
            normalizeMobileScroll();
          } else {
            alignDesktop(middleIndex(referenceIndex), reduceMotionQuery.matches ? 0 : 500);
          }
        },
        destroy: function () {
          if (previousButton) previousButton.removeEventListener('click', handlePreviousClick);
          if (nextButton) nextButton.removeEventListener('click', handleNextClick);
          viewport.removeEventListener('scroll', handleScroll);
          viewport.removeEventListener('keydown', handleKeydown);
          viewport.removeEventListener('pointerdown', handlePointerDown);
          viewport.removeEventListener('pointermove', handlePointerMove);
          viewport.removeEventListener('pointerup', handlePointerUp);
          viewport.removeEventListener('pointercancel', handlePointerUp);
          viewport.removeEventListener('click', handleClick, true);
          viewport.removeEventListener('dragstart', handleDragStart);
          if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', handleMediaChange);
          else mobileQuery.removeListener(handleMediaChange);
          if (navigationUnlockTimer) window.clearTimeout(navigationUnlockTimer);
          wrapper.style.removeProperty('transition-duration');
          wrapper.style.removeProperty('transform');
          viewport.classList.remove('professional-references__custom-slider');
          viewport.removeAttribute('tabindex');
          slideSets.remove();
        }
      });
    });
  }

  function focusFormStatuses(root) {
    matchesIncludingRoot(root, '[data-professional-form-status]').forEach(function (status) {
      if (focusedStatuses.has(status)) return;
      focusedStatuses.add(status);
      window.setTimeout(function () {
        status.focus();
      }, 0);
    });
  }

  function init(root) {
    initRoomSolutions(root || document);
    initNativeReferenceCarousels(root || document);
    focusFormStatuses(root || document);
  }

  function destroy(root) {
    matchesIncludingRoot(root, '[data-professional-room-solutions]').forEach(function (section) {
      var controller = roomControllers.get(section);
      if (!controller) return;
      controller.destroy();
      roomControllers.delete(section);
    });

    matchesIncludingRoot(root, '[data-professional-references]').forEach(function (section) {
      var controller = referenceControllers.get(section);
      if (!controller) return;
      controller.destroy();
      referenceControllers.delete(section);
    });
  }

  function getBlockId(event) {
    if (event.detail && event.detail.blockId) return String(event.detail.blockId);
    var block = event.target && event.target.closest ? event.target.closest('[data-block-id]') : null;
    return block ? block.getAttribute('data-block-id') : '';
  }

  function handleBlockSelect(event) {
    var blockId = getBlockId(event);
    if (!blockId) return;

    var roomSection = event.target.closest && event.target.closest('[data-professional-room-solutions]');
    if (roomSection) {
      var roomController = roomControllers.get(roomSection);
      var roomItem = Array.prototype.find.call(roomSection.querySelectorAll('[data-block-id]'), function (item) {
        return item.getAttribute('data-block-id') === blockId;
      });
      if (roomController && roomItem) {
        roomController.activate(Number(roomItem.getAttribute('data-room-index')), false);
      }
      return;
    }

    var referenceSection = event.target.closest && event.target.closest('[data-professional-references]');
    if (!referenceSection) return;

    var referenceController = referenceControllers.get(referenceSection);
    var referenceSlide = Array.prototype.find.call(
      referenceSection.querySelectorAll('.professional-references__slide:not(.swiper-slide-duplicate)[data-block-id]'),
      function (slide) {
        return slide.getAttribute('data-block-id') === blockId;
      }
    );
    if (!referenceController || !referenceSlide) return;

    var referenceIndex = Number(referenceSlide.getAttribute('data-reference-index')) || 0;
    if (typeof referenceController.goToReference === 'function') {
      referenceController.goToReference(referenceIndex);
    }
  }

  window.MyfeltProfessionalSections = {
    init: init,
    destroy: destroy,
    version: '1.6.0'
  };

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:block:select', handleBlockSelect);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }
})();
